import { ref } from 'vue';
import {log} from "@/composables/useLog";
import { getTranslationsForLocale } from "@/composables/useTranslationsAPI";

const t=ref (null)
const languagePopoverOpen=ref (false)
const languagePopoverMobileOpen=ref (false)
const roSelected=ref (true)
const enSelected=ref (false)
const bgSelected=ref (false)
const geSelected=ref (false)
const frSelected=ref (false)
const spSelected=ref (false)
const itSelected=ref (false)
const ruSelected=ref (false)
const cnSelected=ref (false)
const trSelected=ref (false)
const huSelected=ref (false)

// DB overrides cache, keyed by locale code
const dbOverrides = ref({})

// Current locale code tracker
const currentLocale = ref('ro')

function changeLanguage(lang) {
    log("imported "+lang)
    translation(lang)
    log("am schimbat limba in:")
    log(t.value.country_code)
    languagePopoverOpen.value=false
    languagePopoverMobileOpen.value=false
}

function openLanguagePopover() {
    languagePopoverOpen.value=true
}
function openLanguageMobilePopover() {
    languagePopoverMobileOpen.value=true
}

const messages= {
    ro: require('@/locales/ro.json'),
    en: require('@/locales/en.json'),
    sp: require('@/locales/sp.json'),
    fr: require('@/locales/fr.json'),
    ge: require('@/locales/ge.json'),
    bg: require('@/locales/bg.json'),
    ru: require('@/locales/ru.json'),
    it: require('@/locales/it.json'),
    tr: require('@/locales/tr.json'),
    hu: require('@/locales/hu.json'),
    ci: require('@/locales/ci.json'),
}

// Deep merge: source overrides target, nested objects merged recursively
function deepMerge(target, source) {
    if (!source || typeof source !== 'object') return target
    if (!target || typeof target !== 'object') return source
    const result = { ...target }
    for (const key of Object.keys(source)) {
        if (source[key] !== null && typeof source[key] === 'object' && !Array.isArray(source[key])
            && typeof result[key] === 'object' && result[key] !== null && !Array.isArray(result[key])) {
            result[key] = deepMerge(result[key], source[key])
        } else {
            result[key] = source[key]
        }
    }
    return result
}

// Convert flat API records [{key:"common.search", value:"..."}] to nested object
function flatToNested(translations) {
    const result = {}
    for (const item of translations) {
        const parts = item.key.split('.')
        let current = result
        for (let i = 0; i < parts.length - 1; i++) {
            if (!current[parts[i]] || typeof current[parts[i]] !== 'object') {
                current[parts[i]] = {}
            }
            current = current[parts[i]]
        }
        current[parts[parts.length - 1]] = item.value
    }
    return result
}

// Get the base messages for a locale, with DB overrides merged on top
function getMessagesForLocale(lang) {
    const langKey = lang === 'cn' ? 'ci' : lang
    const base = messages[langKey] || messages.en
    const overrides = dbOverrides.value[lang]
    if (overrides && Object.keys(overrides).length > 0) {
        return deepMerge(base, overrides)
    }
    return base
}

t.value= messages.ro

const translation=(lang)=>{
    unselectFlags().then(()=>{
        currentLocale.value = lang
        if(lang=='en'){
            log(1)
            t.value= getMessagesForLocale('en')
            enSelected.value=true
        }
        else if(lang=='ro'){
            log(2)
            t.value= getMessagesForLocale('ro')
            roSelected.value=true
        }
        else if(lang=='ru'){
            t.value= getMessagesForLocale('ru')
            ruSelected.value=true
        }
        else if(lang=='fr'){
            t.value= getMessagesForLocale('fr')
            frSelected.value=true
        }
        else if(lang=='sp'){
            t.value= getMessagesForLocale('sp')
            spSelected.value=true
        }
        else if(lang=='it'){
            t.value= getMessagesForLocale('it')
            itSelected.value=true
        }
        else if(lang=='bg'){
            t.value= getMessagesForLocale('bg')
            bgSelected.value=true
        }
        else if(lang=='hu'){
            t.value= getMessagesForLocale('hu')
            huSelected.value=true
        }
        else if(lang=='tr'){
            t.value= getMessagesForLocale('tr')
            trSelected.value=true
        }
        else if(lang=='ge'){
            t.value= getMessagesForLocale('ge')
            geSelected.value=true
        }
        else if(lang=='cn'){
            t.value= getMessagesForLocale('cn')
            cnSelected.value=true
        }
        else{
            t.value= getMessagesForLocale('en')
        }
    })
}

const unselectFlags = async () => {
    roSelected.value=false
    enSelected.value=false
    bgSelected.value=false
    geSelected.value=false
    frSelected.value=false
    spSelected.value=false
    itSelected.value=false
    ruSelected.value=false
    cnSelected.value=false
    trSelected.value=false
    huSelected.value=false
}

// Load DB translations for a specific locale, cache and re-apply
async function loadDbTranslations(token, locale) {
    try {
        const result = await getTranslationsForLocale(token, locale)
        if (!result.error && result.translations && result.translations.length > 0) {
            dbOverrides.value[locale] = flatToNested(result.translations)
            log("Loaded " + result.translations.length + " DB overrides for locale: " + locale)
            // Re-apply if this is the current locale
            if (currentLocale.value === locale) {
                t.value = getMessagesForLocale(locale)
            }
        }
    } catch (err) {
        log("Error loading DB translations for " + locale + ": " + err)
    }
}

// Load DB translations for the current locale
async function loadAllDbTranslations(token) {
    const locale = currentLocale.value || 'ro'
    await loadDbTranslations(token, locale)
}

export {
    changeLanguage,
    languagePopoverOpen,
    t,
    openLanguagePopover,
    openLanguageMobilePopover,
    languagePopoverMobileOpen,
    roSelected,
    enSelected,
    bgSelected,
    geSelected,
    frSelected,
    spSelected,
    itSelected,
    ruSelected,
    cnSelected,
    trSelected,
    dbOverrides,
    currentLocale,
    deepMerge,
    flatToNested,
    loadDbTranslations,
    loadAllDbTranslations,
    messages,
}
